const Header = ({ title, rightContent, leftContent, isDarkMode }) => {
	return (
		<header className={`${isDarkMode ? 'bg-gray-800 bg-opacity-50' : 'bg-white bg-opacity-50'} backdrop-blur-md shadow-lg border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-300'}`}>
			<div className='max-w-8xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center'>
				<h1 className={`${isDarkMode ? 'text-gray-100' : 'text-gray-800'} text-3xl font-semibold`}>{title}</h1>
				{leftContent && <div>{leftContent}</div>}
				{rightContent && <div>{rightContent}</div>}
			</div>
		</header>
	);
};

export default Header;
